const headers = {
    'Content-Type': 'application/json',
};

const handleHttpError = (statusCode) => {
    switch (statusCode) {
        case 400:
            return { error: true, message: 'Bad Request', statusCode };
        case 401:
            return { error: true, message: 'Unauthorized', statusCode };
        case 403:
            return { error: true, message: 'Forbidden', statusCode };
        case 404:
            return { error: true, message: 'Not Found', statusCode };
        case 500:
            return { error: true, message: 'Internal Server Error', statusCode };
        default:
            return { error: true, message: 'Unexpected Error', statusCode };
    }
};

const graphqlUrl = `${process.env.REACT_APP_CONTENTFUL_URL}`;
export const post = async (
    query
) => {
    const payload = { query: query };
    const options = {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(payload),
    };

    return fetch(graphqlUrl, options)
        .then((response) => {
            if (!response.ok) {
                return response
                    .json()
                    .then((errorData) => {
                        return handleHttpError(response.status);
                    })
                    .catch(() => {
                        return handleHttpError(response.status);
                    });
            }
            return response.json();
        })
        .catch((error) => {
            return handleHttpError(error.message);
        });
};
